import React, { useState } from "react";

const FullStackJava = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const syllabusData = {
    courseOverview: {
      title: "Course Overview",
      content: (
        <>
          <p className="font-bold text-sm">Objective:</p> Master Full Stack Java
          development to build robust web applications using Java, front-end
          technologies, and databases.
          <p className="font-bold text-sm">Duration:</p> 30 days, 1 hour per
          day.
          <p className="font-bold text-sm">Prerequisites:</p> Basic programming
          knowledge (preferably Java or another language), understanding of
          HTML/CSS, and interest in web development.
          <p className="font-bold text-sm">Tools Needed:</p> Java JDK, IntelliJ
          IDEA or Eclipse, MySQL, Apache Tomcat, Spring Boot,
          HTML/CSS/JavaScript, React (optional), and a code editor (e.g., VS
          Code).
        </>
      ),
    },
    dailySchedule: {
      title: "Daily Schedule",
      days: [
        {
          day: "Day 1: Introduction to Full Stack Java Development",
          objective:
            "Understand the basics of full stack development with Java.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is Full Stack Development?</li>
                <li>Role of Java in full stack development.</li>
                <li>Overview of front-end, back-end, and database layers.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Install Java JDK and set up an IDE (e.g., IntelliJ).</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 2: Java Basics Refresher",
          objective: "Review core Java concepts for full stack development.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Variables, data types, and operators.</li>
                <li>Control structures (if-else, loops).</li>
                <li>Introduction to object-oriented programming (OOP).</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Write a simple Java program with OOP concepts.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 3: Advanced Java Concepts",
          objective: "Deepen understanding of Java for back-end development.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Inheritance, polymorphism, and encapsulation.</li>
                <li>Exception handling and file I/O.</li>
                <li>Introduction to collections (ArrayList, HashMap).</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Implement a program using collections and exceptions.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 4: Introduction to HTML and CSS",
          objective: "Learn front-end basics with HTML and CSS.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Structure of HTML and basic tags.</li>
                <li>CSS basics (selectors, properties, layouts).</li>
                <li>Responsive design fundamentals.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a simple HTML page with CSS styling.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 5: JavaScript Fundamentals",
          objective: "Add interactivity with JavaScript.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Introduction to JavaScript (variables, functions).</li>
                <li>DOM manipulation and events.</li>
                <li>Basic form validation.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Add JavaScript to validate a form.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 6: Introduction to Databases with MySQL",
          objective:
            "Understand database management for full stack applications.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>
                  What is a database and its role in full stack development.
                </li>
                <li>Installing and setting up MySQL.</li>
                <li>Basic SQL commands (SELECT, INSERT, UPDATE).</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a simple MySQL database and table.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 7: Advanced SQL and Database Design",
          objective: "Master SQL queries and database design.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>JOINs, GROUP BY, and subqueries.</li>
                <li>Database normalization and relationships.</li>
                <li>Connecting Java to MySQL (JDBC).</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Write complex SQL queries and connect to Java.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 8: Introduction to Servlets",
          objective: "Learn server-side programming with Java Servlets.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>
                  What are Servlets and their role in back-end development.
                </li>
                <li>Setting up Apache Tomcat server.</li>
                <li>Creating a basic Servlet.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Develop a simple Servlet application.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 9: JSP (JavaServer Pages) Basics",
          objective: "Understand JSP for dynamic web content.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Introduction to JSP and its advantages.</li>
                <li>JSP syntax and directives.</li>
                <li>Integrating JSP with Servlets.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a JSP page and connect it to a Servlet.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 10: Introduction to Spring Framework",
          objective: "Explore the Spring Framework for Java applications.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is Spring and its components.</li>
                <li>Setting up Spring Boot.</li>
                <li>Creating a basic Spring application.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Set up and run a Spring Boot project.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 11: Spring MVC Basics",
          objective: "Learn Model-View-Controller architecture with Spring.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Understanding MVC pattern.</li>
                <li>Creating controllers and views.</li>
                <li>Handling HTTP requests.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Build a simple Spring MVC application.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 12: Spring Data JPA",
          objective: "Integrate databases with Spring using JPA.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Introduction to JPA and Hibernate.</li>
                <li>Mapping Java objects to database tables.</li>
                <li>Basic CRUD operations with Spring Data.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Implement CRUD operations with Spring Data JPA.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 13: RESTful Web Services with Spring",
          objective: "Develop REST APIs using Spring Boot.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What are RESTful services?</li>
                <li>Creating REST endpoints with Spring Boot.</li>
                <li>Handling JSON data.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Build a RESTful API with Spring Boot.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 14: Introduction to Front-End Frameworks",
          objective: "Explore front-end development with React (optional).",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Overview of front-end frameworks (React, Angular).</li>
                <li>Setting up a React project.</li>
                <li>Creating components and props.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Build a basic React component.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 15: Integrating Front-End with Back-End",
          objective: "Connect front-end and back-end layers.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Using REST APIs in front-end applications.</li>
                <li>Handling HTTP requests with Fetch or Axios.</li>
                <li>Basic authentication concepts.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Connect a React app to a Spring Boot API.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 16: Security Basics in Full Stack Java",
          objective: "Learn security practices for web applications.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Common security threats (SQL injection, XSS).</li>
                <li>Implementing basic authentication (Spring Security).</li>
                <li>Securing REST APIs.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Add basic authentication to a Spring application.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 17: Deployment Basics",
          objective: "Understand how to deploy full stack applications.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Introduction to web servers and cloud platforms.</li>
                <li>Deploying a Java app to Apache Tomcat.</li>
                <li>Basic cloud deployment (e.g., Heroku).</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Deploy a simple app to a local Tomcat server.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 18: Version Control with Git",
          objective: "Learn version control for collaborative development.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Introduction to Git and GitHub.</li>
                <li>Basic commands (commit, push, pull).</li>
                <li>Collaborating with branches.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Initialize a Git repository and push to GitHub.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 19: Testing Java Applications",
          objective: "Implement testing for full stack Java apps.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Importance of testing in development.</li>
                <li>Unit testing with JUnit.</li>
                <li>Integration testing basics.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Write a JUnit test for a Java class.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 20: Building RESTful Microservices",
          objective: "Develop microservices with Spring Boot.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What are microservices?</li>
                <li>Creating multiple microservices with Spring Boot.</li>
                <li>Inter-service communication.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Build a simple microservice with Spring Boot.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 21: Caching and Performance Optimization",
          objective: "Improve application performance with caching.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Introduction to caching in Java.</li>
                <li>Using Spring Cache with Ehcache.</li>
                <li>Performance tuning techniques.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Implement caching in a Spring application.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 22: API Documentation with Swagger",
          objective: "Document APIs for better collaboration.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is API documentation?</li>
                <li>Integrating Swagger with Spring Boot.</li>
                <li>Generating interactive API docs.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Add Swagger to a Spring Boot API.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 23: Introduction to DevOps Basics",
          objective: "Understand DevOps practices for deployment.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is DevOps and its benefits.</li>
                <li>Introduction to CI/CD pipelines.</li>
                <li>Using Maven for build automation.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Configure a simple Maven build file.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 24: Debugging and Troubleshooting",
          objective: "Learn to debug and troubleshoot Java applications.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Common bugs in full stack applications.</li>
                <li>Using IDE debugging tools.</li>
                <li>Logging with Log4j or SLF4J.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Debug a sample Java application.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 25: Final Project – Planning",
          objective: "Plan the final full stack Java project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min discussion):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Overview of the final project.</li>
                <li>
                  Suggested project ideas (e.g., e-commerce site, task manager).
                </li>
                <li>Planning architecture and database design.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a project plan and ER diagram.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 26: Final Project – Front-End Development",
          objective: "Develop the front-end for the project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Designing the UI with HTML/CSS/JavaScript.</li>
                <li>Integrating React (if chosen).</li>
                <li>Creating responsive layouts.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Build the front-end interface.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 27: Final Project – Back-End Development",
          objective: "Develop the back-end with Spring Boot.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Setting up Spring Boot controllers and services.</li>
                <li>Integrating with the database using JPA.</li>
                <li>Creating REST APIs.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Implement the back-end logic.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 28: Final Project – Integration and Testing",
          objective: "Integrate and test the full stack application.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Connecting front-end to back-end APIs.</li>
                <li>Unit and integration testing.</li>
                <li>Debugging and fixing issues.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Integrate and test the application.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 29: Final Project – Deployment",
          objective: "Deploy the full stack Java application.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Preparing the app for deployment.</li>
                <li>Deploying to a cloud platform (e.g., Heroku).</li>
                <li>Configuring domain and security.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Deploy the project to a cloud server.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 30: Final Project – Presentation",
          objective: "Present the completed full stack Java project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Preparing a live demo or report.</li>
                <li>Discussing challenges and solutions.</li>
                <li>Presenting to peers or instructors.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Present the deployed project.</li>
              </ul>
            </>
          ),
        },
      ],
    },
    learningOutcomes: {
      title: "Learning Outcomes",
      content: (
        <>
          <p className="text-sm">
            By the end of this course, learners will be able to:
          </p>
          <ul className="list-disc pl-4 text-xs">
            <li>
              Develop full stack web applications using Java and Spring Boot.
            </li>
            <li>
              Design and implement front-end interfaces with HTML, CSS, and
              JavaScript.
            </li>
            <li>Integrate and manage databases with MySQL and JPA.</li>
            <li>Deploy a complete application to a cloud platform.</li>
          </ul>
        </>
      ),
    },
    finalProjectIdeas: {
      title: "Suggested Final Project Ideas",
      content: (
        <>
          <ul className="list-disc pl-4 text-xs">
            <li>
              <span className="font-bold text-sm">E-commerce Website:</span>{" "}
              Build a simple online store with product listings and a cart.
            </li>
            <li>
              <span className="font-bold text-sm">Task Management App:</span>{" "}
              Create a web app to manage tasks with user authentication.
            </li>
            <li>
              <span className="font-bold text-sm">Blog Platform:</span> Develop
              a blogging site with user posts and comments.
            </li>
          </ul>
        </>
      ),
    },
    additionalNotes: {
      title: "Additional Notes",
      content: (
        <>
          <ul className="list-disc pl-4 text-xs">
            <li>
              Practice with real-world projects (e.g., GitHub repositories).
            </li>
            <li>
              Explore additional resources (e.g., Spring documentation, Java
              tutorials).
            </li>
            <li>Use discussion time for troubleshooting and code reviews.</li>
          </ul>
          <p className="text-sm">
            This syllabus provides a structured progression from Java basics to
            full stack development over 30 days.
          </p>
        </>
      ),
    },
  };

  // Function to handle enrollment (replace with actual enrollment logic)
  const handleEnroll = () => {
    alert("Enroll Now clicked! (Add your enrollment logic here)");
  };

  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      {/* Hero Section */}
      <header className="bg-gradient-to-r from-purple-600 to-indigo-600 py-8 text-center">
        <h1 className="text-2xl font-bold mb-1 text-white">
          Full Stack Java Development Syllabus
        </h1>
        <p className="text-sm text-white">
          Master Full Stack Java (30 Hours – 1 Hour Per Day)
        </p>
      </header>

      {/* Training Availability Banner */}
      <div className="fixed top-34 left-80v right-4 bg-yellow-200 border border-yellow-400 rounded-lg p-3 text-center shadow-md z-10">
        <h2 className="text-sm font-semibold text-indigo-800">
          Training Available
        </h2>
        <p className="text-xs text-gray-700">Online Class | Physical Class</p>
        <button
          onClick={handleEnroll}
          className="mt-2 px-4 py-1 bg-orange-600 text-white text-xs rounded-lg hover:bg-orange-700 transition duration-300"
        >
          Enroll Now
        </button>
      </div>

      <div className="max-w-4xl mx-auto p-2 pt-16 pb-16">
        {/* Course Overview */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("courseOverview")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.courseOverview.title}
            <span>{expandedSections["courseOverview"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["courseOverview"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.courseOverview.content}
            </div>
          )}
        </div>

        {/* Daily Schedule */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("dailySchedule")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.dailySchedule.title}
            <span>{expandedSections["dailySchedule"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["dailySchedule"] && (
            <div className="p-1 bg-white">
              {syllabusData.dailySchedule.days.map((day, index) => (
                <div
                  key={index}
                  className="mb-1 border border-gray-100 rounded-lg"
                >
                  <h3
                    onClick={() => toggleSection(`day${index}`)}
                    className="bg-gray-50 p-1 cursor-pointer flex justify-between items-center text-xs font-medium text-gray-600 hover:bg-gray-100"
                  >
                    {day.day}
                    <span>{expandedSections[`day${index}`] ? "▲" : "▼"}</span>
                  </h3>
                  {expandedSections[`day${index}`] && (
                    <div className="p-1 bg-white text-gray-600 leading-tight">
                      <p className="font-bold text-sm">Objective:</p>{" "}
                      {day.objective}
                      {day.topics}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Learning Outcomes */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("learningOutcomes")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.learningOutcomes.title}
            <span>{expandedSections["learningOutcomes"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["learningOutcomes"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.learningOutcomes.content}
            </div>
          )}
        </div>

        {/* Final Project Ideas */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("finalProjectIdeas")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.finalProjectIdeas.title}
            <span>{expandedSections["finalProjectIdeas"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["finalProjectIdeas"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.finalProjectIdeas.content}
            </div>
          )}
        </div>

        {/* Additional Notes */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("additionalNotes")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.additionalNotes.title}
            <span>{expandedSections["additionalNotes"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["additionalNotes"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.additionalNotes.content}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FullStackJava;
